export default __webpack_public_path__ + "static/media/tvetLogin.6094d250.png";